module.exports = __webpack_public_path__ + "static/media/efs_minsk_map_rail_glow.4e6a779d.jpg";